import { TableHeaderConfigWithType } from '../../../components/_EOS/Table'
import {  
  WorkOrderInBoundGrid
} from '../../../interfaces/WorkOrder/WorkOrder'
import { utcToLocal } from '../../../utils/dateHelper'

export const getHeaderConfigHeaders: () => TableHeaderConfigWithType<WorkOrderInBoundGrid>[] =
  () => {
    return [
      { field: 'asnId', title: 'ID ASN', sortable: true },
      { field: 'asnNumber', title: 'Nro ASN', sortable: true },
      {
        field: 'receivedDate',
        title: 'Fecha Recepción',
        formater: (_id, row) =>
          utcToLocal(row?.receivedDate || '', 'dd/MM/yyyy'),
        sortable: true
      },
      { field: 'supplierName', title: 'Proveedor', sortable: true },      
      { field: 'unitsQty', title: 'Uds. En ASN', sortable: true },
      { field: 'locatedQty', title: 'Uds. Recibidas', sortable: true },
      { field: 'differenceQty', title: 'Uds. Pendientes', sortable: true }

    ]
  }
